export default __webpack_public_path__ + "static/media/HR-1.e3f659f3.jpg";